import { Injectable } from '@angular/core';

import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

import { LoggerService } from '../logger.service';
import { WindowService } from '../ssr/window.service';

@Injectable({ providedIn: 'root' })
export class CallNumberPlugin {
  constructor(private callNumber: CallNumber, private windowService: WindowService, private loggerService: LoggerService) {}

  public call(contactNumber: string): Promise<void> {
    return this.callNumber
      .callNumber(contactNumber, true)
      .then(() => {})
      .catch((error: unknown) => {
        this.loggerService.info({
          component: 'CallNumberPlugin',
          message: "couldn't start phone call",
          details: { error },
          fromPlugin: true,
        });

        // If for some reason we can't use the Cordova plugin to make the call
        // we'll try to open the phone dialer using the tel protocol
        if (this.windowService.isWindowDefined) {
          this.windowService.window.location.href = `tel:${contactNumber}`;
        }
      });
  }
}
